// extracted by mini-css-extract-plugin
export default {"buttonsDiv":"uw","hideButtonBar":"vw","bottomRibbonContainer":"ww","scroll":"xw","default":"yw","nextBtn":"zw","MyClassEnterDone":"Aw"};
    if(module.hot) {
      // 1713996746599
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  